// extracted by mini-css-extract-plugin
export default {"costItemName":"afe-table_costItemName__Onfvf","select":"afe-table_select__8JmB3"};